import { createAction } from '@reduxjs/toolkit';
import { FlowStoppedReason } from '@constants/flows';

interface StartFlowPayload {
  flowId: string;
  options?: Record<string, any>;
}

interface StopFlowPayload {
  flowId: string;
  reason: FlowStoppedReason;
}

interface AddFlowDataPayload {
  flowId: string;
  data: Record<string, any>;
}

interface RemoveFlowDataPayload {
  flowId: string;
  key: string;
}

interface ChangeFlowStepPayload {
  flowId: string;
  step: string;
  direction: 'forward' | 'backward';
}

export const startFlow = createAction(
  'Start flow',
  (
    flowId: string,
    options: Record<string, any> = {},
  ): { payload: StartFlowPayload } => ({
    payload: {
      flowId,
      options,
    },
  }),
);

export const stopFlow = createAction(
  'Stop flow',
  (
    flowId: string,
    reason: FlowStoppedReason = FlowStoppedReason.CLOSED,
  ): { payload: StopFlowPayload } => ({
    payload: {
      flowId,
      reason,
    },
  }),
);

export const addFlowData = createAction(
  'Add flow data',
  (
    flowId: string,
    data: Record<string, any>,
  ): { payload: AddFlowDataPayload } => ({
    payload: {
      flowId,
      data,
    },
  }),
);

export const removeFlowData = createAction(
  'Remove flow data',
  (flowId: string, key: string): { payload: RemoveFlowDataPayload } => ({
    payload: {
      flowId,
      key,
    },
  }),
);

export const resetFlow = createAction(
  'Reset flow',
  (flowId: string): { payload: { flowId: string } } => ({
    payload: {
      flowId,
    },
  }),
);

export const changeFlowStep = createAction(
  'Change flow step',
  (
    flowId: string,
    step: string,
    direction: 'forward' | 'backward' = 'forward',
  ): {
    payload: ChangeFlowStepPayload;
  } => ({
    payload: {
      flowId,
      step,
      direction,
    },
  }),
);

export const stepForward = createAction('Advance flow step');
export const stepBack = createAction('Flow step back');
export const changeAuthType = createAction('Switch between reg/signin steps');
